import React, { useState } from "react";
// import "./AnnouncementForm.css";

const AnnouncementForm = () => {
  const [announcement, setAnnouncement] = useState({
    title: "",
    date: "",
    introduction: "",
    details: "",
    callToAction: "",
    contactInfo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAnnouncement((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send data to PHP backend
    fetch("https://chaman.gob.pk/eac_backend/submit-announcement.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    })
      .then((response) => response.json())
      .then((data) => {
        alert("Announcement submitted successfully!");
        setAnnouncement({
          title: "",
          date: "",
          introduction: "",
          details: "",
          callToAction: "",
          contactInfo: "",
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("An error occurred. Please try again.");
      });
  };

  return (
    <div className="arms-container">
      <form onSubmit={handleSubmit}>
        <div className="left-section">
        <div>
            <label>Date:</label>
              <input
                type="date"
                name="date"
                value={announcement.date}
                onChange={handleChange}
                required
              />
          </div>
          <div>
            <label>Title:</label>
              <input
                type="text"
                name="title"
                value={announcement.title}
                onChange={handleChange}
                required
              />
          </div>
          
          {/* <div>
            <label>Introduction:</label>
              <input
                name="introduction"
                value={announcement.introduction}
                onChange={handleChange}
                required
              />
          </div> */}
          <div>
            <label>Details:</label>
              <input
                name="details"
                value={announcement.details}
                onChange={handleChange}
                required
              />
          </div>
          {/* <div>
            <label>Call to Action:</label>
              <input
                type="text"
                name="callToAction"
                value={announcement.callToAction}
                onChange={handleChange}
                required
              />
          </div>
          <div>
            <label>Contact Information:</label>
              <input
                type="text"
                name="contactInfo"
                value={announcement.contactInfo}
                onChange={handleChange}
                required
              />
          </div> */}
        <button type="submit" className="submit-btn">
          Publish
        </button>
        </div>
      </form>
    </div>
  );
};

export default AnnouncementForm;